var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 29,
    viewBox: "0 0 31 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6044 0.802443C14.9721 0.0623873 16.0279 0.0623891 16.3956 0.802445L20.1362 8.33114C20.2818 8.6242 20.5616 8.82748 20.8853 8.8754L29.2015 10.1065C30.0189 10.2275 30.3452 11.2315 29.7549 11.8099L23.7507 17.694C23.5169 17.923 23.4101 18.252 23.4645 18.5746L24.8635 26.8642C25.001 27.679 24.147 28.2996 23.4145 27.917L15.963 24.0248C15.6729 23.8733 15.3271 23.8733 15.037 24.0248L7.58551 27.917C6.85304 28.2996 5.99896 27.679 6.13648 26.8642L7.53548 18.5746C7.58993 18.252 7.48307 17.923 7.24934 17.694L1.24505 11.8099C0.654844 11.2315 0.981075 10.2275 1.79854 10.1065L10.1147 8.8754C10.4384 8.82748 10.7182 8.6242 10.8638 8.33114L14.6044 0.802443Z",
    fill: "#0999B9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/Star.53a16f8441081ab901dc9325b32e305a.svg";
export { ForwardRef as ReactComponent };